'use client';

import { useState, useEffect } from 'react';

export default function Home() {
  const [log, setLog] = useState<string>('System initializing...');

  // Simulated fake tracker cookie
  useEffect(() => {
    document.cookie = "prowler_local_session=SPIDEY{d3c0y_tr4ck3r_fl4g_h4h4}; path=/";
  }, []);

  const login = async () => {
    setLog('Connecting to authentication server...');
    const res = await fetch('/api/auth');
    const data = await res.json();
    setLog(`[AUTH] ${JSON.stringify(data, null, 2)}`);
  };

  const getOrders = async () => {
    setLog('Fetching encrypted deployment orders...');
    const res = await fetch('/api/tracker');
    const data = await res.json();
    setLog(`[TRACKER] ${JSON.stringify(data, null, 2)}`);
  };

  return (
    <main className="min-h-screen bg-black text-[#ff00ff] font-mono p-8 selection:bg-purple-900">
      <div className="max-w-2xl mx-auto border-2 border-purple-800 p-8 shadow-[0_0_30px_rgba(128,0,128,0.3)] rounded-3xl bg-[#0a000a]">
        <header className="mb-8 border-b-2 border-purple-900 pb-4 flex items-center justify-between">
          <div>
            <h1 className="text-4xl font-black tracking-widest text-transparent bg-clip-text bg-gradient-to-r from-purple-500 to-pink-500 uppercase italic">
              Prowler Net
            </h1>
            <p className="text-xs uppercase tracking-[0.4em] text-purple-600 mt-2">
              Mercenary Deployment Protocol
            </p>
          </div>
          <div className="text-right">
            <span className="animate-pulse inline-block w-4 h-4 rounded-full bg-purple-500 shadow-[0_0_10px_#ff00ff]"></span>
          </div>
        </header>

        <section className="space-y-6">
          <p className="text-sm text-purple-400">
            Welcome to the underground network. Authenticate to receive your encrypted JWT. 
            Once authenticated, poll the tracker for target data.
          </p>

          <div className="flex gap-4">
            <button
              onClick={login}
              className="flex-1 bg-purple-900/40 hover:bg-purple-800 border border-purple-500 py-3 uppercase font-black tracking-widest transition-all rounded shadow-[0_0_15px_rgba(128,0,128,0.5)]"
            >
              1. Assign Token
            </button>
            <button
              onClick={getOrders}
              className="flex-1 bg-pink-900/40 hover:bg-pink-800 border border-pink-500 py-3 uppercase font-black tracking-widest transition-all rounded shadow-[0_0_15px_rgba(255,0,255,0.5)] text-pink-400 hover:text-white"
            >
              2. Read Target Data
            </button>
          </div>

          <div className="bg-[#050005] border border-purple-900 h-64 p-4 rounded overflow-auto text-sm shadow-inner">
            <pre className="whitespace-pre-wrap font-mono text-purple-300">{log}</pre>
          </div>
        </section>
      </div>
    </main>
  );
}
